/* eslint-disable no-useless-escape, max-len */
const entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;',
  '`': '&#x60;',
  '=': '&#x3D;',
};

const reverseEntityMap = {};
const escaped = [];
Object.entries(entityMap).forEach(([entity, escapedEntity]) => {
  reverseEntityMap[escapedEntity] = entity;
  escaped.push(escapedEntity);
});

const unescapeRegex = new RegExp(escaped.join('|'), 'g');

export const escape = string => string && String(string).replace(/[&<>"'`=\/]/g, s => entityMap[s]);

export const unescape = string => string && String(string).replace(unescapeRegex, s => reverseEntityMap[s]);
